'use strict';

/*
    Решение взято отсюда https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    Прошлая реализация была завязана на Math.random(), что давало коллизии в некотрых случаях
    так же добавлен window.performance в качестве замены new Date
*/


var log2 = function(n){
    return Math.log(n) / Math.log(2);
}

var trueRandom = (function() {
  var crypt = window.crypto || window.msCrypto;

  if (crypt && crypt.getRandomValues) {
      // if we have a crypto library, use it
      var random = function(min, max) {
          var rval = 0;
          var range = max - min;
          if (range < 2) {
              return min;
          }

          var bits_needed = Math.ceil(log2(range));
          if (bits_needed > 53) {
            throw new Error("We cannot generate numbers larger than 53 bits.");
          }
          var bytes_needed = Math.ceil(bits_needed / 8);
          var mask = Math.pow(2, bits_needed) - 1;
          // 7776 -> (2^13 = 8192) -1 == 8191 or 0x00001111 11111111

          // Create byte array and fill with N random numbers
          var byteArray = new Uint8Array(bytes_needed);
          crypt.getRandomValues(byteArray);

          var p = (bytes_needed - 1) * 8;
          for(var i = 0; i < bytes_needed; i++ ) {
              rval += byteArray[i] * Math.pow(2, p);
              p -= 8;
          }

          // Use & to apply the mask and reduce the number of recursive lookups
          rval = rval & mask;

          if (rval >= range) {
              // Integer out of acceptable range
              return random(min, max);
          }
          // Return an integer that falls within the range
          return min + rval;
      }
      return function() {
          var r = random(0, 1000000000) / 1000000000;
          return r;
      };
  } else {
      // From http://baagoe.com/en/RandomMusings/javascript/
      // Johannes BaagÃ¸e <baagoe@baagoe.com>, 2010
      function Mash() {
          var n = 0xefc8249d;

          var mash = function(data) {
              data = data.toString();
              for (var i = 0; i < data.length; i++) {
                  n += data.charCodeAt(i);
                  var h = 0.02519603282416938 * n;
                  n = h >>> 0;
                  h -= n;
                  h *= n;
                  n = h >>> 0;
                  h -= n;
                  n += h * 0x100000000; // 2^32
              }
              return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
          };

          mash.version = 'Mash 0.9';
          return mash;
      }

      // From http://baagoe.com/en/RandomMusings/javascript/
      function Alea() {
          return (function(args) {
              // Johannes BaagÃ¸e <baagoe@baagoe.com>, 2010
              var s0 = 0;
              var s1 = 0;
              var s2 = 0;
              var c = 1;

              if (args.length == 0) {
                  args = [+new Date()];
              }
              var mash = Mash();
              s0 = mash(' ');
              s1 = mash(' ');
              s2 = mash(' ');

              for (var i = 0; i < args.length; i++) {
                  s0 -= mash(args[i]);
                  if (s0 < 0) {
                      s0 += 1;
                  }
                  s1 -= mash(args[i]);
                  if (s1 < 0) {
                      s1 += 1;
                  }
                  s2 -= mash(args[i]);
                  if (s2 < 0) {
                      s2 += 1;
                  }
              }
              mash = null;

              var random = function() {
                  var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
                  s0 = s1;
                  s1 = s2;
                  return s2 = t - (c = t | 0);
              };
              random.uint32 = function() {
                  return random() * 0x100000000; // 2^32
              };
              random.fract53 = function() {
                  return random() +
                      (random() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
              };
              random.version = 'Alea 0.9';
              random.args = args;
              return random;

          }(Array.prototype.slice.call(arguments)));
      };
      return Alea(  window.performance && window.performance.now && window.performance.now() );
  }
}());

var guid = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c)    {
      var r = trueRandom() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
  });
};

var funnelUid = function(instanceId) {
  var crypt = window.crypto || window.msCrypto || {
    getRandomValues: function(buffer){
      for(var i = 0; i < buffer.length; i++){
        buffer[i] = Math.floor(Math.random() * Math.pow(2, buffer.BYTES_PER_ELEMENT * 8));
      }

      return buffer;
    }
  }

  function random() {
    var value = new Uint32Array(1);

    crypt.getRandomValues(value);

    return value[0];
  }

  function reverseBytes(value) {
    return (((value & 0xFF) << 24 >>> 0) | ((value & 0xFF00) << 8 >>> 0) | ((value >>> 8) & 0xFF00 >>> 0) | ((value >>> 24) & 0xFF >>> 0)) >>> 0;
  }

  function now() {
    return Math.floor(Date.now() / 1000);
  }

  function toBase64(buffer) {
    var bytes  = new Uint8Array(buffer),
        binary = '';

    for(var i = 0; i < bytes.byteLength; i++){
      binary += String.fromCharCode(bytes[i]);
    }

    return btoa(binary);
  }

  function userId(id) {
    var id        = id.split('-'),
        node      = parseInt(id[0], 36),
        node_s    = Math.floor(node / 1000),
        node_ms   = node % 1000,
        version   = parseInt(id[1], 36),
        timestamp = now(),
        rand      = random(),
        uid       = new Uint32Array(4);

    // 1 - node, 2 - timestamp, 3 - version, 4 - random
    // 11111111111111111111111111111111222222222222222222222222222222223333333333333333333333333333333344444444444444444444441111111111

    uid[0] = reverseBytes(node_s);
    uid[1] = reverseBytes(timestamp);
    uid[2] = reverseBytes(version);
    uid[3] = reverseBytes(((rand & 0xFFFFFC00) >>> 0) + node_ms);

    return toBase64(uid.buffer);
  }

  return userId(instanceId);
}

module.exports = {
  guid: guid,
  funnelUid: funnelUid
};


//////////////////
// WEBPACK FOOTER
// ./lib/funnel/hash.js
// module id = 4
// module chunks = 1 3